/**
 * The local-storage keys the task composer's selections persist under.
 *
 * They live beside the composer rather than in the agent sessions constants
 * file because the composer is what writes them, and that file is otherwise
 * keyed by session, task and pull shapes the composer has no reason to read.
 */
const AGENT_TASKS_SELECTED_MODEL_VERSION = 1
export const AGENT_TASKS_SELECTED_MODEL_KEY = `AGENT_TASKS_SELECTED_MODEL_v${AGENT_TASKS_SELECTED_MODEL_VERSION}`
export const AGENT_TASKS_REASONING_EFFORT_KEY = 'AGENT_TASKS_REASONING_EFFORT_v1'
export const AGENT_TASKS_MCP_PERMISSION_MODE_KEY = 'AGENT_TASKS_MCP_PERMISSION_MODE_v1'
